import { createApi } from '@reduxjs/toolkit/query/react';
import createBaseQueryWithReauth from '@services/xendit';
import {
  IXenditCheckRecurringResponse,
  IXenditErrorResponse,
  IXenditRecurringPlansResponse,
} from '@pages/subscription/interfaces/xendit.interface';
import {
  ISubscriptionCustomerData,
  IXenditInvoiceResponse,
} from '@pages/subscription/interfaces/form.interface';

export const xenditAPI = createApi({
  reducerPath: 'xenditAPI',
  baseQuery: createBaseQueryWithReauth(`https://api.xendit.co`),
  endpoints: (builder) => ({
    getBalance: builder.query({
      query: () => ({
        url: 'balance',
        method: 'GET',
      }),
      transformResponse: (response: any) => {
        return response;
      },
      transformErrorResponse: (error: IXenditErrorResponse) => {
        return error;
      },
    }),
    checkInvoice: builder.query({
      query: (payload) => ({
        url: 'v2/invoices/' + payload,
        method: 'GET',
      }),
      transformResponse: (response: IXenditCheckRecurringResponse) => {
        return response;
      },
      transformErrorResponse: (error: IXenditErrorResponse) => {
        return error.data.message;
      },
    }),
    createCustomer: builder.mutation({
      query: (payload) => ({
        url: 'customers',
        method: 'POST',
        body: payload,
      }),
      transformResponse: (response: ISubscriptionCustomerData) => {
        return response;
      },
      transformErrorResponse: (error: IXenditErrorResponse) => {
        return error.data.message;
      },
    }),
    createInvoice: builder.mutation({
      query: (payload) => ({
        url: 'v2/invoices',
        method: 'POST',
        body: payload,
      }),
      transformResponse: (response: IXenditInvoiceResponse) => {
        return response;
      },
      transformErrorResponse: (error: IXenditErrorResponse) => {
        return error.data.message;
      },
    }),
    recurring: builder.mutation({
      query: (payload) => ({
        url: 'recurring/plans',
        method: 'POST',
        body: payload,
      }),
      transformResponse: (response: IXenditRecurringPlansResponse) => {
        return response;
      },
      transformErrorResponse: (error: IXenditErrorResponse) => {
        return error;
      },
    }),
  }),
});

export const {
  useGetBalanceQuery,
  useCheckInvoiceQuery,
  useLazyCheckInvoiceQuery,
  useCreateCustomerMutation,
  useCreateInvoiceMutation,
  useRecurringMutation,
} = xenditAPI;
